import { registerGroup, registerSymbol } from '@visactor/vrender-kits';

export function loadWeatherComponent() {
  registerGroup();
  registerSymbol();
}
